export enum TransactionStatus {
    Created = 0,
    WatingPayment = 1,
    PaymentConfirmed = 2,
    Sended = 3,
    WatingTaking = 4,
    Finished = 5,
    Cancelled = 6
}